<template>
  <div>
    <Header/>
    <Navigationzj :toptNavi="2"/>
    <div class="zmpp_con w1200">
      <div class="zmpp_con_tit" id="zmp" style="padding: 10px 0;">知名品牌</div>
      <div style="height: 10px;"></div>
      <div class="bd tj_index_r w1200" style="float: inherit!important;margin-top: 15px;width: 1200px;">
        <div class="picList clearfix">
          <div class="index_big">
            <ul class="clearfix">
              <li v-for="(item,index) in FamousBrandsList" :key="index" style="position: relative;">
                <router-link :to="{path:'/Ppxq',query:{ bid:item.id }}" target="_blank" >
                  <span style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;text-align: center;position: absolute;bottom: 0;left: 0;width: 100%;height: 20px;background: rgba(0, 0, 0, 0.25);font-size: 14px;color: #ffffff;line-height: 20px;z-index: 3;">{{ item.title }}</span>
                  <img v-real-img="item.img" src="../../assets/images/zwtp.jpg" height="60" :title="item.title"/>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 20px;"></div>
    <div class="zmpp_con_tit" style="padding: 10px 0;">全部品牌</div>
    <div class="ppzx_abc">
      <ul class="clearfix">
        <li v-for="(item,index) in lettetList" :key="index" :class="{ontype:index==isactive}" @click="cutActive(item,index)">{{ item }}</li>
        <!-- <li code="B">B</li>
        <li code="C">C</li>
        <li code="D">D</li>
        <li code="E">E</li>
        <li code="F">F</li>
        <li code="G">G</li>
        <li code="H">H</li>
        <li code="I">I</li>
        <li code="J">J</li>
        <li code="K">K</li>
        <li code="L">L</li>
        <li code="M">M</li>
        <li code="N">N</li>
        <li code="O">O</li>
        <li code="P">P</li>
        <li code="Q">Q</li>
        <li code="R">R</li>
        <li code="S">S</li>
        <li code="T">T</li>
        <li code="U">U</li>
        <li code="V">V</li>
        <li code="W">W</li>
        <li code="X">X</li>
        <li code="Y">Y</li>
        <li code="Z">Z</li> -->
      </ul>
    </div>
    <div class="bd tj_index_r w1200" style="float: inherit!important;margin-top: 15px;">
      <div class="picList clearfix">
        <div class="index_big">
          <ul class="clearfix appendbrand">
            <li v-for="(item,index) in LetterBrandsList" :key="index">
              <router-link :to="{path:'/Ppxq',query:{ bid:item.id }}" target="_blank" style="height:103px;position: relative;">
                <span style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;text-align: center;position: absolute;bottom: 0;left: 0;width: 100%;height: 20px;background: rgba(0, 0, 0, 0.25);font-size: 14px;color: #ffffff;line-height: 20px;z-index: 3;">{{ item.title }}</span>
                <img v-real-img="item.img" src="../../assets/images/zwtp.jpg" height="60" :alt="item.title" :title="item.title" />
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  <Footer/>
  </div>
</template>
<script>
import api from '@/api/brand'
import Header from '@/components/Header'
import Navigationzj from '@/components/Navigationzj'
import Footer from '@/components/Footer'

export default {
  name: 'Brand',
  components: {
    Header,
    Navigationzj,
    Footer
  },
  data () {
    return {
      code: this.$route.query.cid || 'A',
      isactive: 0,
      FamousBrandsList: [],
      LetterBrandsList: [],
      lettetList: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
    }
  },
  mounted () {
    this.getFamousBrands()
    this.getLetterBrandsList()
  },
  methods: {
    getFamousBrands () {
      api.getFamousBrands().then(res => {
        this.FamousBrandsList = res.items
      })
    },
    getLetterBrandsList () {
      api.getLetterBrandsList({'code': this.code}).then(res => {
        this.LetterBrandsList = res.items
      })
    },
    cutActive (item, index) {
      this.isactive = index
      api.getLetterBrandsList({'code': item}).then(res => {
        this.LetterBrandsList = res.items
      })
    }
  }
}
</script>
<style scoped>
  .zk_con{
    display: none;
  }
  .ontype {
    color: #fff;
    background: #749cff;
  }
  .index_big {
    border: none;
  }
  .index_big ul {
    margin: 0 -5px;
    border: none;
  }
  .pp-banner {
    position: relative;
  }
  .pp-banner .bd {
    height: 280px;
    overflow: hidden;
  }
  .pp-banner .bd li {
    height: 280px;
  }
  .pp-banner .hd {
    position: absolute;
    bottom: 15px;
    left: 0;
    z-index: 10;
    width: 100%;
    text-align: center;
  }
  .pp-banner .hd li {
    display: inline-block;
    margin: 0 3px;
    vertical-align: middle;
    width: 30px;
    height: 10px;
    background: #fff;
    cursor: pointer;
  }
  .pp-banner .hd li.on {
    background: #07357b;
  }

  .index_big ul li {
    width: 189px;
    margin: 3px 5px;
    border: 1px solid #efefef;
  }

  .index_big ul li a {
    width: 100%;
  }

  .index_big ul li img {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/view/brand/ppzx.vue